import { PkCard } from '@uefadigital/panenka-react';
import clsx from 'clsx';
import parseHtmlToReact from 'html-react-parser';
import { memo, useMemo } from 'react';

import { trackCardElement } from '@services/GoogleTagManagerService';
import { getVideoUrl, getArticleUrl } from '@services/LinkRuleService';
import ErrorBoundary from '@shared/ErrorBoundary';
import PictureHelper from '@shared/PictureHelper';
import { stripHtml } from '@utilities/dom';

import * as classes from './styles.module.scss';

const imgFormats = ['0@p1'];
const entityTypeMap = {
  story: 'Article',
  video: 'Video',
  default: 'Promo',
} as const;

const Card = ({ item }) => {
  const cardTitle = stripHtml(item?.mainMedia?.headline);
  const entityType = item?._attributes?.['emk-class'];
  const trackingName = entityTypeMap[entityType] ?? entityTypeMap['default'];

  const type = entityType === 'video' ? 'video' : 'article';

  const href = useMemo(
    () => (type === 'video' ? getVideoUrl : getArticleUrl)(item?._attributes?.['data-id']),
    [item?._attributes, type],
  );

  const trackingData = {
    name: `${trackingName} - ${cardTitle}`,
    id: item?.mainMedia?.id,
    category: 'match at a glance mini card',
  };

  return (
    <ErrorBoundary>
      <PkCard className={classes.card} content='over'>
        <div
          slot='heading'
          className={clsx({
            [classes.cardContent]: true,
            [classes.cardContentVideo]: type === 'video',
          })}
          ref={trackCardElement(trackingData)}
        >
          <a href={href}>
            <PictureHelper
              formats={imgFormats}
              image={item?.mainMedia?.mainMedia?.image}
              title={item?.mainMedia?.mainMedia?.title}
            />
          </a>
        </div>
        <a href={href} className={classes.cardTitle} slot='body'>
          {parseHtmlToReact(item?._text ?? '')}
        </a>
      </PkCard>
    </ErrorBoundary>
  );
};

export default memo(Card);
